<template>
  <modal
    class=""
    :show.sync="isOpenLocal"
    scrollable
    header-classes="bg-primary p-2 flex items-center "
    size="lg"
    @close="handleClose"
  >
    <!-- <h6 slot="header" class="modal-title text-white pl-4 font-semibold">
      Add News
    </h6> -->

    <div class="">
      <h6 class="modal-title text-black font-semibold">Add Achievements</h6>

      <div class="d-flex h-28 mt-4">
        <img
          v-if="image"
          :src="image"
          ref="cover"
          class="object-fit w-2/4 h-28 mr-5 rounded"
        />

        <!-- default image -->
        <img
          v-else
          src="@/assets/images/wgrid6.jpg"
          alt=""
          class="object-cover w-2/4 h-28 mr-5 rounded"
        />
        <FileUploader
          ref="FileUploader"
          v-show="true"
          :image="image"
          :onSuccess="handleSuccess"
          class="object-cover w-2/4 rounded profimage"
          style="height: auto"
        />
      </div>

      <div class="mt-2 md:flex">
        <div class="md:w-1/2 lg:w-1/2 w-full pt-4">
          <p class="input-title-black">Course Name</p>
          <base-input
            v-model="cname"
            placeholder="Enter Course Name"
            name="Course Name"
            class="cust-form-border"
          ></base-input>

          <!-- <b-form-checkbox value="cred" size="sm"
            ><p>This credential does not expire</p></b-form-checkbox
          > -->
        </div>
        <div class="md:pl-4 lg:pl-4 ml-0 mt-4 md:w-1/2 lg:w-1/2 w-full">
          <p class="input-title-black">Author Name</p>
          <base-input
            name="Author Name"
            v-model="author"
            placeholder="Enter Author Name"
            class="cust-form-border"
          ></base-input>
        </div>
      </div>

      <div class="">
        <div class="w-full mt-6">
          <p class="input-title-black">Issued Date</p>
          <!-- <div class="md:flex"> -->
          <div class="ml-0 md:w-1/2 lg:w-1/2 w-full pt-4">
            <b-form-group>
              <date-picker
                required
                :config="{ allowInput: true }"
                placeholder="Select Date"
                v-model="issuedate"
                format="DD-MM-YYYY"
                class="formborder"
                valueType="format"
              />
            </b-form-group>
            <!-- </div> -->
            <!-- <div class="md:w-1/2 lg:w-1/2 md:pl-5 w-full pt-4">
              <b-form-select>
                v-model="issend" :options= "users" class="text-base text-black "
              </b-form-select>
            </div> -->
          </div>
        </div>
      </div>

      <div class="">
        <div class="mt-6 w-full">
          <p class="input-title-black">Expired Date</p>
          <div class="md:flex">
            <!-- <div class="md:w-1/2 lg:w-1/2 w-full pt-4">
              <b-form-select>
                v-model="exp" :options= "users" class="text-base text-black"
              </b-form-select>
            </div> -->
            <div class="md:w-1/2 lg:w-1/2 w-full py-1 rounded">
              <b-form-group>
                <date-picker
                  required
                  :config="{ allowInput: true }"
                  placeholder="Select Date"
                  v-model="expiredate"
                  format="DD-MM-YYYY"
                  valueType="format"
                  class="formborder"
                >
                </date-picker>
              </b-form-group>
            </div>
          </div>
        </div>
      </div>

      <template slot="footer">
        <base-button
          type="primary"
          @click="addAchievement"
          :disabled="isdisabled"
          >SAVE CHANGES</base-button
        >
        <base-button
          type="secondary"
          class="ml-auto border"
          @click="handleClose"
          >CLOSE</base-button
        >
      </template>
    </div>
  </modal>
</template>

<script>
import DatePicker from "vue2-datepicker";
import FileUploader from "@/components/FileUploader";
import coverImage from "./coverImage.vue";
import { mapState } from "vuex";
export default {
  components: {
    DatePicker,
    FileUploader,
    coverImage,
  },
  data() {
    return {
      image: null,
      file: null,
      cname: "",
      author: "",
      issuedate: "",
      expiredate: "",
      isdisabled: false,
      issued: [
        { value: null, text: "select Designation", disable: "true" },
        "Student",
        "Teacher",
      ],
      issend: [
        { value: null, text: "select Designation", disable: "true" },
        "Student",
        "Teacher",
      ],
      expend: [
        { value: null, text: "select Designation", disable: "true" },
        "Student",
        "Teacher",
      ],
      exp: [
        { value: null, text: "select Designation", disable: "true" },
        "Student",
        "Teacher",
      ],
    };
  },

  props: {
    isOpen: Boolean,
  },
  computed: {
    ...mapState("auth", ["userData"]),
    isOpenLocal: {
      get() {
        return this.isOpen;
      },
      set(val) {
        if (!val) {
          this.handleClose();
        }
      },
    },
  },
  methods: {
    handleSuccess(image) {
      this.file = image;
      this.readerData(image);
    },
    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));

        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },
    HandleDelete() {
      this.image = null;
      this.coverImage = null;
    },

    handleClose() {
      this.$emit("close");
    },
    async addAchievement(event) {
      // event.preventDefault();

      let FormData = require("form-data");
      let payload = new FormData();
      payload.append("courseName", this.cname);
      payload.append("authorName", this.author);
      payload.append("issuedDate", this.issuedate);
      payload.append("expiredDate", this.expiredate);
      payload.append("file", this.file);
      payload.append("userid", this.userData._id);

      if (this.cname && this.author && this.issuedate && this.file) {
        this.isdisabled = true;
        const data = await this.$store.dispatch(
          "achievement/addAchievement",
          payload
        );

        if (data.code == 200) {
          this.$swal.fire({
            text: " Achievement Added Successfully",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          this.isdisabled = false;
        }

        this.image = null;
        this.file = null;
        this.cname = "";
        this.author = "";
        this.issuedate = "";
        this.expiredate = "";

        const payload2 = {
          userid: this.userData._id,
        };
        await this.$store.dispatch("achievement/getAchievement", payload2);
        this.handleClose();
      } else {
        this.$swal.fire({
          text: " Please Fill All Field",
          icon: "warning",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
      }
    },
  },
};
</script>

<style>
.formborder {
  border: 2px solid #830c81;
  border-radius: 0.375rem;
  width: 100% !important;
}
</style>
